import {
    SET_DOWN_PAYMENT,
    SET_LOAN_TERM,
    SET_LOAN_INTEREST,
    SET_MOSAIC_DOWN_PAYMENT,
    SET_MOSAIC_TERM,
    SET_LOAN_PROVIDER,
    SET_SHOW_LOAN,
    SET_LOAN,
} from './constants';

export const setLoan = loan => ({
    type: SET_LOAN,
    loan,
});
export const setDownPayment = downPayment => ({
    type: SET_DOWN_PAYMENT,
    downPayment,
});

export const setLoanTerm = loanTerm => ({
    type: SET_LOAN_TERM,
    loanTerm,
});

export const setLoanInterest = interest => ({
    type: SET_LOAN_INTEREST,
    interest,
});

export const setMosaicTerm = mosaicTerm => ({
    type: SET_MOSAIC_TERM,
    mosaicTerm,
});

export const setMosaicDownPayment = mosaicDownPayment => ({
    type: SET_MOSAIC_DOWN_PAYMENT,
    mosaicDownPayment,
});

export const setLoanProvider = loanProvider => ({
    type: SET_LOAN_PROVIDER,
    loanProvider,
});

export const setShowLoan = showLoan => ({
    type: SET_SHOW_LOAN,
    showLoan,
});



// WEBPACK FOOTER //
// ./src/containers/common/loan/actions.js